import { arrayOf, bool, number, oneOfType, shape, string } from 'prop-types'

import {
  CHARGE_SEARCH_PARAMS,
  INIT_CROSSSELL,
  INIT_SLIDER,
} from 'shared/store/ducks/events'
import { withI18n } from 'shared/utils/withI18n'
import { getFinalImageProps } from 'views/containers/crosssell/helpers'
import withCrossSell from 'views/enhancers/withCrossSell'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'
import { i18nType, sizesPropType } from 'views/utils/propTypes'
import ProductType from 'views/utils/propTypes/api/Product_v1'

import SliderComponent from './SliderComponent'
import { getSliderTitle, shouldShowBuyButton } from './utils'

const CrosssellSliderHorizontal = props => {
  const {
    widgetdetails,
    shopConfig: {
      crosssell: { widgets },
      tenant,
    },
    publicRuntimeConfig: {
      pageProperties: { experiments },
    },
    crossSellType,
    wid,
    items,
    metadata,
    imageMinWidth,
    imageMaxWidth,
    imageSizes,
    i18n,
    redirectToCart,
    excludedProducts,
    ...rest
  } = props

  if (!items) {
    return null
  }

  let finalWid = wid
  if (!wid) {
    if (crossSellType) {
      finalWid = widgets[crossSellType]
    }
  }

  const title = getSliderTitle(
    i18n,
    widgets,
    finalWid,
    widgetdetails.title,
    tenant
  )

  return (
    <SliderComponent
      items={items}
      metadata={metadata}
      moreLinkTitle={widgetdetails.moreLinkTitle}
      title={title}
      wid={finalWid}
      widgets={widgets}
      adaptableArrows
      titleIsHtml
      redirectToCart={redirectToCart}
      showBuyButton={shouldShowBuyButton(wid, widgets, experiments)}
      excludedProducts={excludedProducts}
      {...getFinalImageProps(imageMinWidth, imageMaxWidth, imageSizes)}
      {...rest}
    />
  )
}

CrosssellSliderHorizontal.propTypes = {
  shopConfig: shape({}),
  publicRuntimeConfig: shape({}),
  items: arrayOf(shape(ProductType)),
  metadata: shape({}),
  crossSellType: string,
  wid: oneOfType([number, string]),
  visibleItemCount: oneOfType([number, string]),
  pid: string,
  start: number,
  csize: number,
  'ctxcat.ct': string,
  'ctxcat.cid': string,
  searchLink: bool,
  widgetdetails: shape({
    title: string,
    moreLinkTitle: string,
  }),
  lazyLoadAll: bool,
  imageMinWidth: number,
  imageMaxWidth: number,
  imageSizes: oneOfType([string, sizesPropType]),
  i18n: i18nType.isRequired,
  redirectToCart: bool,
  excludedProducts: string,
  excludePidsInCart: bool,
}

CrosssellSliderHorizontal.defaultProps = {
  shopConfig: shape({
    crosssell: shape({
      widgets: shape({}).isRequired,
    }).isRequired,
  }).isRequired,
  publicRuntimeConfig: shape({
    pageProperties: shape({
      experiments: arrayOf(shape({}).isRequired).isRequired,
    }).isRequired,
  }).isRequired,
  crossSellType: null,
  wid: null,
  visibleItemCount: 6,
  items: null,
  metadata: {},
  pid: null,
  start: 0,
  csize: 50,
  'ctxcat.ct': null,
  'ctxcat.cid': null,
  searchLink: false,
  widgetdetails: {
    title: null,
    moreLinkTitle: null,
  },
  lazyLoadAll: false,
  imageMinWidth: null,
  imageMaxWidth: null,
  imageSizes: null,
  redirectToCart: false,
  excludedProducts: null,
  excludePidsInCart: false,
}

CrosssellSliderHorizontal.publishAfterRender = [
  INIT_SLIDER,
  CHARGE_SEARCH_PARAMS,
  INIT_CROSSSELL,
]

const CrosssellSlider = withCrossSell('/crosssell/sliderHorizontal')(
  withShopAndRuntimeConfig(withI18n()(CrosssellSliderHorizontal))
)

export default CrosssellSlider
